"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.web = void 0;
exports.web = {
    web_clientGreeting: "Добро пожаловать!",
    web_menuLogIn: "Войти",
    web_menuLogOut: "Выйти из аккаунта",
    web_menuAdmin: "Администрирование",
    web_usersList: "Пользователи",
    web_regionsList: "Регионы",
};
//# sourceMappingURL=web.js.map